module.exports = __webpack_public_path__ + "img/002-instagram.fc23b902.svg";